import PropTypes from "prop-types"
import React, { useState, useEffect, useCallback, useRef } from "react"
import {
  Container,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Label,
  Input,
} from "reactstrap"
import "react-multi-carousel/lib/styles.css"

import { Link, useParams, useLocation, useNavigate } from "react-router-dom"

import awicon from "../../assets/images/services-icon/coin.png"
import { SECURITY_KEY, BASE_URL } from "../../global";
import Select from "react-select"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
//i18n
import { withTranslation } from "react-i18next"
import { sample } from "lodash"
import axios from "axios"
// import { BASE_URL } from "../../global";

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import Loader from "react-spinner-loader"

import { fabric } from "fabric"
import { pdfjs } from "react-pdf"
import jsPDF from "jspdf"
import { debounce } from 'lodash';
import LZString from 'lz-string';

const ManualWorkSheet = props => {
  document.title = "MyGooRoo Student App"
  const { key } = useParams();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [pk_activity_key, set_pk_activity_key] = useState(null);
  const [IsType, setIsType] = useState(null);
  const [IsQuestionNo, setIsQuestionNo] = useState(1);
  const [IsStKey, setIsStKey] = useState(null);
  useEffect(() => {
      
  const { type, st_key } = location.state || {};
 
      if (key && key!='' && type && type!=null && st_key && st_key!='') {
        set_pk_activity_key(key);
        setIsType(type);
        setIsQuestionNo(1);
        setIsStKey(st_key);
      }else{
        toast.error("Sorry, Key missing!", {
          autoClose: 3000, // 3 seconds in this example
          onClose: () => {window.history.back()},
        });
      }
  }, [location]);

  const [loader, setLoader] = useState(false)
  const [ActivityData, setActivityData] = useState([])

  const [imageUrls, setImageUrls] = useState([])
  const [canvasList, setCanvasList] = useState([])
  const [pdfInstance, setPdfInstance] = useState(null)

  const [currentColor, setCurrentColor] = useState("black")

  const colorRef = useRef()
  colorRef.current = currentColor

  const [drawMode, setDrawMode] = useState(false) // State for text mode
  const drawModeRef = useRef()
  drawModeRef.current = drawMode

  const [textMode, setTextMode] = useState(false) // State for text mode
  const textModeRef = useRef()
  textModeRef.current = textMode

  const [selectedShape, setSelectedShape] = useState("circle") // State for selected shape
  const [shapMode, setShapMode] = useState(false)
  const shapModeRef = useRef()
  shapModeRef.current = shapMode

  const shapDataRef = useRef()
  shapDataRef.current = selectedShape

  const [zoomLevel, setZoomLevel] = useState(1)


  const [pointerMode, setPointerMode] = useState(true);


  const fontSizeRef = useRef(34); // Default font size
  const [fontSize, setFontSize] = useState(34); // State to display in UI
  const [brushSize, setBrushSize] = useState(10);
  const [strokeSize, setStrokeSize] = useState(2);
  const canvasListRef = useRef([]);

  const authTutorUser = JSON.parse(localStorage.getItem("authTutorUser")) || null
  const navigate = useNavigate()
  useEffect(() => {
    fetchData()
  }, [pk_activity_key])

 

  const fetchData = async () => {
   if (authTutorUser && authTutorUser != "" && authTutorUser != null) {
      if (pk_activity_key && pk_activity_key != null && pk_activity_key != "") {
        setLoader(true)
        setActivityData([])
        axios.defaults.headers.common["Authorization"] = `Bearer ${authTutorUser}`
        axios
          .post(
            BASE_URL+"session/StudentQuestions",
            {
              pk_activity_key: pk_activity_key,
              subject_id: IsType,
              pk_student_key : IsStKey
            }
          )
          .then(responseActivity => {
            // Assuming the API response is an array of objects with 'id' and 'value' properties
            setLoader(false)

            if (responseActivity.data.LessonActivitiesQuestions.length > 0) {
              setActivityData(responseActivity.data)

              responseActivity.data.LessonActivitiesQuestions.forEach(
                (activityQuestion, index2) => {
                  //if (activityQuestion.question && activityQuestion.question.length > 0) {
                  let answerLength = activityQuestion.StudentAnsAttempts.length

                  if (parseInt(IsHomework) === 1) {
                    if (answerLength <= 0) {
                     
                    }
                  } else {
                    if (answerLength <= 0) {
                     
                      //console.log('attented');
                    }
                  }

                  // }
                }
              )
            } else {
              toast.error("Question data not found", {
                autoClose: 3000, // 3 seconds
                onClose: () => {
                  history.back(); // Navigate back in history after toast is closed
                }
              });
              setActivityData([])
            }
          })
          .catch(error => {
            setLoader(false)
            console.log(error)
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        setLoader(false)
       
      }
    } else {
       setLoader(false);
      navigate("/login")
    }
  }

  
  const downloadPdf = () => {
    resetZoom()

    // Function to resize and compress image manually using canvas
    const compressImage = canvas => {
      // Resize and compress the canvas image
      const dataUrl = canvas.toDataURL("image/jpeg", 1.0)

      const img = new Image()
      img.src = dataUrl

      return new Promise(resolve => {
        img.onload = () => {
          // Create a temporary canvas for resizing
          const offCanvas = document.createElement("canvas")
          const ctx = offCanvas.getContext("2d")
          const maxWidth = 1500; // Higher resolution for better quality
          const maxHeight = 1500;
  
          const width = img.width;
          const height = img.height;
          const scale = Math.min(maxWidth / width, maxHeight / height, 1);
  
          offCanvas.width = Math.round(width * scale);
          offCanvas.height = Math.round(height * scale);
  
          // Apply high-quality scaling
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = "high";
          ctx.drawImage(img, 0, 0, offCanvas.width, offCanvas.height);
  

          // Get the resized image as a data URL (compressed further by adjusting quality)
          const resizedDataUrl = offCanvas.toDataURL("image/jpeg", 1.0) // Further compress the image

          resolve(resizedDataUrl) // Return the resized image
        }
      })
    }


    
    // Generate PDF from resized and compressed canvas images
    const generatePdf = async () => {
      const doc = new jsPDF()
      doc.internal.scaleFactor = 2.0; 
      // Compress and add each canvas image to the PDF
      for (let i = 0; i < canvasList.length; i++) {
        const canvas = canvasList[i]
        const compressedImage = await compressImage(canvas)

        // Add compressed image to the PDF
        const pageWidth = doc.internal.pageSize.getWidth()
        const pageHeight = doc.internal.pageSize.getHeight()
        // Set high-contrast black text color
        doc.setTextColor(0, 0, 0); // Ensures deep black text
        doc.setFont("helvetica", "bold"); // Use a bold font for better readability

        doc.addImage(compressedImage, "JPEG", 0, 0, pageWidth, pageHeight)

        // Add a new page if it's not the last image
        if (i !== canvasList.length - 1) {
          doc.addPage()
        }
      }

      // Save the PDF
      doc.save("worksheet_submission_" + generateRandomFileName() + ".pdf")
    }

    generatePdf()
  }
  // Function to generate a random 13-digit number
  const generateRandomFileName = () => {
    const min = 1000000000000 // Minimum 13-digit number
    const max = 9999999999999 // Maximum 13-digit number
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  const fetchCanvasHistoryFromBackend = async () => {
    try {
      const response = await axios.post(BASE_URL + "session/getTutorCanvasData", {
        pk_activity_key: pk_activity_key,
      });
      if (response.data && response.data.length > 0) {
        return response.data[0].tutor_canvas_data; // <-- important!
      }
      return null;
    } catch (error) {
      console.error("Failed to fetch canvas data", error);
      return null;
    }
  };
  const [pdfLoadObject, setLoadObject] = useState(null)

  function loadCanvasFromJson(canvas, compressedJsonList, pageIndex) {
  return new Promise((resolve) => {
    let allObjects = [];
    compressedJsonList.forEach((compressed, idx) => {
      if (!compressed) return;

      const json = LZString.decompressFromUTF16(compressed);
      const parsedJson = typeof json === 'string' ? JSON.parse(json) : json;

      if (parsedJson.objects) {
        const matchingObjects = parsedJson.objects.filter(
          obj => obj.type !== 'image' && obj.pageIndex == pageIndex
        );
        allObjects.push(...matchingObjects);
      }
    });

    // Build a new JSON to load
    const newJson = {
      version: '4.6.0', // or match your Fabric version
      objects: allObjects
    };

    canvas.loadFromJSON(newJson, () => {
      canvas.renderAll();
      resolve();
    }, (o, object) => {
      console.log("Loaded object on page", pageIndex, ":", object);
    });
  });
}

   useEffect(() => {
    // not conver to url
    // https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/activity_pdf/english_activity_pdf/Year_5_Vocabulary_S__Year_5_Vocabulary_S_1710151837_Q.pdf

    //DIRECT URL
    //https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/tutor/library/1707203418570_PdfForm.pdf

    //student direct URL
    //https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/student/submissions/worksheet_submission_1711431708116.pdf
    if (ActivityData && ActivityData != "") {
      let pdfUrl = ""
      if (
        ActivityData &&
        ActivityData.LessonActivitiesQuestions &&
        ActivityData.LessonActivitiesQuestions.length > 0 &&
        ActivityData.LessonActivitiesQuestions[0] &&
        ActivityData.LessonActivitiesQuestions[0].StudentAnsAttempts.length >
          0 &&
        ActivityData.LessonActivitiesQuestions[0].StudentAnsAttempts[0]
          .student_answer
      ) {
        pdfUrl =
          ActivityData.LessonActivitiesQuestions[0].StudentAnsAttempts[0]
            .student_answer
      } else if (
        ActivityData &&
        ActivityData.fk_sub_id &&
        ActivityData.activity_type &&
        parseInt(ActivityData.activity_type) === 7 &&
        ActivityData.activity_node &&
        ActivityData.activity_node.length > 0
      ) {
        if (parseInt(ActivityData.fk_sub_id) === 1) {
          pdfUrl =
            "https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/activity_pdf/english_activity_pdf/" +
            ActivityData.activity_node[0].file_name
        } else if (parseInt(ActivityData.fk_sub_id) === 2) {
          pdfUrl =
            "https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/activity_pdf/math_activity_pdf/" +
            ActivityData.activity_node[0].file_name
        }
      } else if (
        ActivityData &&
        ActivityData.fk_sub_id &&
        ActivityData.activity_type &&
        parseInt(ActivityData.activity_type) === 5 &&
        ActivityData.activity_node &&
        ActivityData.activity_node.length > 0
      ) {
        pdfUrl = ActivityData.activity_node[0].link
          ? ActivityData.activity_node[0].link
          : ""
      }

      // const pdfUrl1 = 'https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/activity_pdf/math_activity_pdf/Angles_Triangles_an_Angles_Triangles_an_1702259819_Q.pdf'; // Update with your PDF URL
      pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

      const fetchPdfAndConvert = async () => {
        try {
          const response = await fetch(pdfUrl)
          const blob = await response.blob()
          const reader = new FileReader()

          reader.onload = async e => {
            const data = atob(e.target.result.replace(/.*base64,/, ""))
            let savedCanvasJsons = null;
            if(ActivityData?.status === 1){
              // Fetch saved canvas JSON data from backend
              savedCanvasJsons = await fetchCanvasHistoryFromBackend();
            }

            renderPages(data, savedCanvasJsons)
          }

          reader.readAsDataURL(blob)
        } catch (error) {
          console.error("Error fetching or converting PDF:", error)
        }
      }
      

      const renderPages = async (data, savedCanvasJsons = null)  => {
        const imagesList = []
        const canvases = []
        const pdf = await pdfjs.getDocument({ data }).promise

        const canvasContainer = document.getElementById("Canvas_list")

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i)
          const viewport = page.getViewport({ scale: 1.5 })

          // Create a div for the canvas and page number display
          const pageDiv = document.createElement("div")
          pageDiv.classList.add("canvas-page-container")

          const pageNumberDiv = document.createElement("div")
          pageNumberDiv.classList.add("d-flex", "justify-content-center")

          const pageNumberParagraph = document.createElement("p")
          pageNumberParagraph.textContent = `${i}/${pdf.numPages}`

          pageNumberDiv.appendChild(pageNumberParagraph)
          pageDiv.appendChild(pageNumberDiv)

          const canvasContainerDiv = document.createElement("div")
          canvasContainerDiv.classList.add("d-flex", "justify-content-center")

          const canvasElem = document.createElement("canvas")
          canvasElem.id = `fabric-canvas-${i}` // Unique ID for each canvas
          canvasElem.height = viewport.height
          canvasElem.width = viewport.width

          canvasContainerDiv.appendChild(canvasElem)
          pageDiv.appendChild(canvasContainerDiv)

          canvasContainer.appendChild(pageDiv)

          const fabricCanvas = new fabric.Canvas(canvasElem)
          
          const renderContext = {
            canvasContext: fabricCanvas.getContext("2d"),
            viewport: viewport,
          }

          await page.render(renderContext).promise
         


          fabricCanvas.on("mouse:down", function (event) {
            handleCanvasClick(event, fabricCanvas)
            handleShapeCreation(event, fabricCanvas)
          })

         fabricCanvas.on('object:added', () => {
            saveCanvasHistory(fabricCanvas);     // save to local history stack
            debouncedSaveCanvas();            // save to backend
          });

          fabricCanvas.on('object:removed', () => {
            saveCanvasHistory(fabricCanvas);     
            debouncedSaveCanvas();              
          });

          canvases.push(fabricCanvas)

          const img = canvasElem.toDataURL("image/png")
          imagesList.push(img)
        }

        setImageUrls(imagesList)
        setCanvasList(canvases)
        setPdfInstance(pdf)
        setLoadObject(savedCanvasJsons)
        canvasListRef.current = canvases; // keep ref in sync
      }
      fetchPdfAndConvert()
    }
  }, [ActivityData])
 useEffect(() => {
    //enable draw option
    canvasList.forEach(canvas => {
      canvas.isDrawingMode = drawMode // Enable drawing mode
    })
  }, [drawMode])
  
  const saveCanvasHistory = (canvas) => {
    const json = canvas.toJSON();
    setHistoryStack(prev => [...prev, json]);
    setRedoStack([]); // clear redo stack on new action
  };
 
  const saveCanvasToBackend = async (canvasList) => {
    try {
      const canvasJsons = canvasList
      .map((canvas, index) => {
        const objects = canvas.getObjects().filter(obj => obj.type !== 'image');
        if (objects.length === 0) return null;
         // Attach pageIndex to each object
          objects.forEach(obj => {
            obj.set('pageIndex', index);
          });
        const json = canvas.toJSON([
          'type', 'left', 'top', 'scaleX', 'scaleY', 'angle',
          'width', 'height', 'text', 'fill', 'fontSize', 'fontFamily', 'pageIndex'
        ]);
        return LZString.compressToUTF16(JSON.stringify(json));
      })
      .filter(Boolean); // remove nulls

      return await axios.post(BASE_URL + "session/saveTutorCanvasData", {
        pk_activity_key: pk_activity_key,
        canvas_data: JSON.stringify(canvasJsons),
      });
    } catch (error) {
      console.error("Failed to save canvas", error);
    }
  };

  useEffect(() => {
    canvasListRef.current = canvasList;
  }, [canvasList]);

  const handleSaveProgress = async(canvasList) => {
    canvasListRef.current = canvasList;
    let response = await saveCanvasToBackend(canvasList);
    if (response?.data === 1) {
      toast.success("Worksheet progress saved successfully.", {
        autoClose: 1000, // 1 second
      });
    } else {
      toast.error("Unable to save worksheet progress.", {
        autoClose: 1000, // 1 second
      });
    }


  }

  // Debounce to save entire canvasList
  const debouncedSaveCanvas = debounce(() => {
    saveCanvasToBackend(canvasListRef.current);
  }, 3000);

  const handleCanvasClick = (event, canvas) => {
    if (textModeRef.current) {
      const pointer = canvas.getPointer(event.e);
      const clickedObject = canvas.findTarget(event.e); // Detect clicked object
  
      if (clickedObject && clickedObject.type === "textbox") {
        // If a text box is clicked, select it instead of creating a new one
        canvas.setActiveObject(clickedObject);
        clickedObject.enterEditing();
        return;
      }
  
      // If no text box is clicked, create a new one
      const textbox = new fabric.Textbox("", {
        left: pointer.x,
        top: pointer.y,
        width: 50,
        fontSize: fontSizeRef.current, // Use the current font size
        fill: colorRef.current, // Set text color
      });
  
      canvas.add(textbox);
      canvas.setActiveObject(textbox);
      textbox.enterEditing();
      textbox.selectAll();
      canvas.renderAll();
    }
  };
  
  const handleShapeCreation = (event, canvas) => {
    if (shapModeRef.current) {
      // Handle shape creation
      const { x, y } = event.pointer

      switch (shapDataRef.current) {
        case "circle":
          const circle = new fabric.Circle({
            radius: 50,
            left: x,
            top: y,
            fill: "transparent", // Set fill color to transparent
            stroke: colorRef.current,
          })
          canvas.add(circle)
          break
        case "rectangle":
          const rectangle = new fabric.Rect({
            width: 100,
            height: 50,
            left: x,
            top: y,
            fill: "transparent", // Set fill color to transparent
            stroke: colorRef.current,
          })
          canvas.add(rectangle)
          break
        case "square":
          const square = new fabric.Rect({
            width: 50,
            height: 50,
            left: x,
            top: y,
            fill: "transparent", // Set fill color to transparent
            stroke: colorRef.current,
          })
          canvas.add(square)
          break
        default:
          break
      }
    }
  }



useEffect(() => {
  if(ActivityData?.status === 1){
    if (!imageUrls || !canvasList) return;

      imageUrls.forEach((imageUrl, index) => {
        const canvas = canvasList[index];
        if (!canvas) return;

        // Clear canvas before loading JSON or background
        canvas.clear();

        // Load saved JSON if exists
        // const savedJson = pdfLoadObject?.[index];
        const savedJson = pdfLoadObject;
        const restoreJsonPromise = savedJson
          ? loadCanvasFromJson(canvas, savedJson, index)  // Pass index here
          : Promise.resolve();

        // After restoring canvas, set background image
        restoreJsonPromise.then(() => {
          fabric.Image.fromURL(imageUrl, (img) => {
            img.set({ selectable: false, evented: false });

            const scaleX = canvas.width / img.width;
            const scaleY = canvas.height / img.height;

            canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
              scaleX,
              scaleY,
            });
          });
        });
      });
  }else{
    if (!imageUrls || !canvasList) return;

    imageUrls.forEach((imageUrl, index) => {
      const canvas = canvasList[index]
 
      fabric.Image.fromURL(imageUrl, img => {
        img.set({
          left: 0,
          top: 0,
          selectable: false, // Disable object selection/movement
          evented: false,
        })
        img.scaleToWidth(canvas.width)
        canvas.add(img)
        canvas.renderAll()
      })
    })
  }
}, [imageUrls, canvasList, pdfLoadObject, ActivityData]);



  //Toggles
  const toggleTextMode = () => {
    setDrawMode(false)
    setShapMode(false)
    setPointerMode(false)
    setTextMode(!textMode) // Toggle text mode state
  }

  const toggleDrawMode = () => {
    setTextMode(false)
    setShapMode(false)
    setPointerMode(false)
    setDrawMode(!drawMode) // Toggle text mode state
    // Update brush color when switching draw mode
    if (!drawMode) {
      canvasList.forEach(canvas => {
        canvas.freeDrawingBrush.color = currentColor;
        canvas.freeDrawingBrush.width = brushSize;
      })
    }
  }

  const toggleShapeMode = value => {
    setTextMode(false)
    setDrawMode(false) // Toggle text mode state
    setShapMode(true) // Toggle text mode state.
    setPointerMode(false)
    setSelectedShape(value)
  }

  const ClickShapeMode = () => {
    setTextMode(false)
    setDrawMode(false) // Toggle text mode state
    setPointerMode(false)
    setShapMode(!shapMode) // Toggle text mode state
  }

  const zoomIn = () => {
    setZoomLevel(prevZoom => prevZoom + 0.1)
    adjustZoom(1.1)
  }

  const zoomOut = () => {
    setZoomLevel(prevZoom => (prevZoom > 0.1 ? prevZoom - 0.1 : prevZoom))
    adjustZoom(0.9)
  }

  const resetZoom = () => {
    setZoomLevel(1)
    adjustZoom(1 / zoomLevel) // Reset to original zoom level (1)
  }

  const adjustZoom = factor => {
    canvasList.forEach(canvas => {
      const zoom = canvas.getZoom() * factor
      canvas.setZoom(zoom)
      canvas.requestRenderAll()
    })
  }

  const removeSelectedObject = () => {
    canvasList.forEach(canvas => {
      const activeObjects = canvas.getActiveObjects(); // Get all selected objects
  
      if (activeObjects.length) {
        activeObjects.forEach(obj => canvas.remove(obj)); // Remove each selected object
  
        canvas.discardActiveObject(); // Deselect objects after removal
        canvas.renderAll(); // Refresh canvas
      }
    });
  };
  
  
  const changeColor = color => {
    setCurrentColor(color)
    if (drawMode) {
      // Set stroke color for drawing objects
      canvasList.forEach(canvas => {
        canvas.freeDrawingBrush.color = color
      })
    } else {
      // Set fill color for shape creation or text color
      canvasList.forEach(canvas => {
        const activeObject = canvas.getActiveObject()
        if (activeObject) {
          if (activeObject.type === "textbox") {
            if (activeObject.selectionStart !== activeObject.selectionEnd) {
              // Apply color only to selected text
              activeObject.setSelectionStyles({ fill: color });
            } else {
              // Apply color to the entire text if no selection
              activeObject.set("fill", color);
            }
            //activeObject.set("fill", color)
          } else {
            activeObject.set("stroke", color)
          }
          canvas.renderAll()
          //saveCanvasToHistory(canvas);
        }
      })
    }
  }
 
 
  
  const increaseFontSize = () => {
    const newSize = fontSizeRef.current + 2;
    fontSizeRef.current = newSize;
    setFontSize(newSize); // Update UI
  
    canvasList.forEach((canvas) => {
      const activeObject = canvas.getActiveObject();
      if (activeObject && activeObject.isType("textbox")) {
        // Temporarily exit editing mode
        activeObject.exitEditing();
        activeObject.set("fontSize", newSize);
        activeObject.enterEditing(); // Re-enter editing mode to maintain cursor position
        canvas.renderAll();
      }
    });
  };
  
  const decreaseFontSize = () => {
    if (fontSizeRef.current > 10) { // Prevent too small sizes
      const newSize = fontSizeRef.current - 2;
      fontSizeRef.current = newSize;
      setFontSize(newSize);
  
      canvasList.forEach((canvas) => {
        const activeObject = canvas.getActiveObject();
        if (activeObject && activeObject.isType("textbox")) {
          // Temporarily exit editing mode
          activeObject.exitEditing();
          activeObject.set("fontSize", newSize);
          activeObject.enterEditing(); // Re-enter editing mode
          canvas.renderAll();
        }
      });
    }
  };
  
  
  
  const increaseBrushSize = () => {
    const newSize = brushSize + 2;
    setBrushSize(newSize);
    canvasList.forEach(canvas => {
      canvas.freeDrawingBrush.width = newSize;
    });
  };
  
  const decreaseBrushSize = () => {
    const newSize = brushSize > 2 ? brushSize - 2 : brushSize;
    setBrushSize(newSize);
    canvasList.forEach(canvas => {
      canvas.freeDrawingBrush.width = newSize;
    });
  };
  
  const togglePointerMode = () => {

    setTextMode(false)
    setShapMode(false)
    setDrawMode(false) // Toggle text mode state
    setPointerMode(prev => !prev);
  
    canvasList.forEach(canvas => {
      if (pointerMode) {
        //canvas.selection = true; // Enable selecting/moving objects
        canvas.defaultCursor = "default";
        //canvas.forEachObject(obj => obj.set({ selectable: true, evented: true }));
      } else {
        //canvas.selection = false; // Disable selection
        canvas.defaultCursor = "pointer";
        //canvas.forEachObject(obj => obj.set({ selectable: false, evented: false }));
      }
      canvas.renderAll();
    });
  };

  const [historyStack, setHistoryStack] = useState([]);
  const [redoStack, setRedoStack] = useState([]);
  const [isLinkSubmit, setLinkSubmit] = useState(false)
  
  const convertAndSendPdf = async () => {
    if (authTutorUser&& authTutorUser!= "" && authTutorUser!= null) {
      try {
        resetZoom() // Reset zoom before converting to PDF
        setLinkSubmit(true)
        const doc = new jsPDF()
        doc.internal.scaleFactor = 2.0; 

        // Function to resize and compress image manually using canvas
        const compressImage = canvas => {
          // Resize and compress the canvas image
          const dataUrl = canvas.toDataURL("image/jpeg", 1.0)

          const img = new Image()
          img.src = dataUrl

          return new Promise(resolve => {
            img.onload = () => {
              // Create a temporary canvas for resizing
              const offCanvas = document.createElement("canvas")
              const ctx = offCanvas.getContext("2d")
              const maxWidth = 1200; // Higher resolution for better quality
              const maxHeight = 1200;

              const width = img.width;
              const height = img.height;
              const scale = Math.min(maxWidth / width, maxHeight / height, 1);

              offCanvas.width = Math.round(width * scale);
              offCanvas.height = Math.round(height * scale);

              // Apply high-quality scaling
              ctx.imageSmoothingEnabled = true;
              ctx.imageSmoothingQuality = "high";
              ctx.drawImage(img, 0, 0, offCanvas.width, offCanvas.height);


              // Get the resized image as a data URL (compressed further by adjusting quality)
              const resizedDataUrl = offCanvas.toDataURL("image/jpeg", 1.0) // Further compress the image

              resolve(resizedDataUrl) // Return the resized image
            }
          })
        }
        
        // Compress and add each canvas image to the PDF
        for (let i = 0; i < canvasList.length; i++) {
          const canvas = canvasList[i]
          const compressedImage = await compressImage(canvas)

          // Add compressed image to the PDF
          const pageWidth = doc.internal.pageSize.getWidth()
          const pageHeight = doc.internal.pageSize.getHeight()

          // Set high-contrast black text color
          doc.setTextColor(0, 0, 0); // Ensures deep black text
          doc.setFont("helvetica", "bold"); // Use a bold font for better readability
          doc.addImage(compressedImage, "JPEG", 0, 0, pageWidth, pageHeight)

          // Add a new page if it's not the last image
          if (i !== canvasList.length - 1) {
            doc.addPage()
          }
        }

        // Save the PDF as a Blob
        const pdfBlob = doc.output("blob")

        // Download file
        // const url = URL.createObjectURL(pdfBlob);
        // const a = document.createElement("a");
        // a.href = url;
        // a.download = "worksheet.pdf";
        // document.body.appendChild(a);
        // a.click();

        // // Remove
        // a.remove();
        // URL.revokeObjectURL(url);

        // Create FormData object to send the Blob
        const formData = new FormData()
        formData.append(
          "pdfFile",
          pdfBlob,
          "worksheet_submission_" + generateRandomFileName() + ".pdf"
        )
        formData.append(
          "pk_lesson_activity_key",
          ActivityData.pk_lesson_activity_key
        ) // Append additional form data
        formData.append("fk_lesson_key", ActivityData.fk_lesson_key) // Append additional form data
        formData.append("activity_type", ActivityData.activity_type) // Append additional form data
        formData.append("fk_sub_id", ActivityData.fk_sub_id) // Append additional form data
        formData.append(
          "question_id",
          ActivityData.LessonActivitiesQuestions[0].fk_question_id
        ) // Append additional form data
        formData.append("fk_ses_key", ActivityData.fk_sest_key) // Append additional form data
        formData.append("old_file", ActivityData?.LessonActivitiesQuestions[0]?.StudentAnsAttempts[0]
            ?.student_answer)
        //console.log('worksheet_submission_'+generateRandomFileName()+'.pdf');
        // Send the FormData to the backend using Axios
        axios.defaults.headers.common["Authorization"] = `Bearer ${authTutorUser}`
        const response = await axios.post(
          BASE_URL + "session/TutorWorkSheetMarked",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        if (parseInt(response.data) === 1) {
          setLinkSubmit(false)
        } else {
          setLinkSubmit(false)
          toast.error("Connection to server lost! Kindly inform admin", {
            autoClose: 3000, // 3 seconds in this example
          })
        }

        // Add any additional handling after sending the PDF to the backend
      } catch (error) {
        setLinkSubmit(false)
        console.error("Error converting or sending PDF:", error)
         toast.error("Connection to server lost! Kindly inform admin", {
            autoClose: 3000, // 3 seconds in this example
          })
        // Add error handling as needed
      }
    } else {
      setLinkSubmit(false)
      navigate("/login")
    }
  }

  //link

  const [ResonTextData, setResonText] = useState("")
  const [modal_standard, setmodal_standard] = useState(false)
  const [modal_standard1, setmodal_standard1] = useState(false)

  const [isFlagReport, setFlagReport] = useState(false)

  const [selectedGroup, setselectedGroup] = useState(null)

  const [selectQuestion, setselectQuestion] = useState(null)

  const tog_standard1 = () => {
    setmodal_standard1(!modal_standard1)
  }

  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }

  const optionGroup = [
    // {
    // label: "Select Subject",
    // options: [
    { label: "Spelling error / Typo", value: "Spelling error / Typo" },
    { label: "The solution is wrong", value: "The solution is wrong" },
    {
      label: "The question is not relevant to the topic",
      value: "The question is not relevant to the topic",
    },
    {
      label: "The question cannot be solved",
      value: "The question cannot be solved",
    },
    {
      label: "The question is incomplete",
      value: "The question is incomplete",
    },
    { label: "Others", value: "Others" },
    // ],
    // },
  ]

  function textareachange(event) {
    const text = event.target.value
    // if (count > 0) {
    setResonText(text)
    // }
    //settextcount(event.target.value.length)
  }
  const tog_standard = data => {
    //console.log(data);
    setmodal_standard(!modal_standard)
    setselectedGroup(null)
    setResonText("")
    setselectQuestion(data ? data : null)
  }

  function submitFlagReport() {
   // if (authTutorUser && authTutorUser != "" && authTutorUser != null) {
      setFlagReport(true)
      //axios.defaults.headers.common["Authorization"] = `Bearer ${authTutorUser}`
      axios
        .post(BASE_URL+"studentSession/flagReport", {
          fk_lesson_activity_key: selectQuestion.fk_lesson_activity_key,
          fk_lesson_activity_question_key:
            selectQuestion.pk_lesson_activity_question_key,
          fk_sub_id: selectQuestion.fk_sub_id,
          question_id: selectQuestion.fk_question_id,
          reson_text: ResonTextData,
          reson: selectedGroup,
        })
        .then(responseFlag => {
          //console.log(responseSessionEnd.data);
          // Assuming the API response is an array of objects with 'id' and 'value' properties
          if (parseInt(responseFlag.data) === 1) {
            tog_standard()
            setFlagReport(false)
            toast.success("Report submitted successfully.", {
              autoClose: 3000, // 3 seconds in this example
            })
          } else {
            tog_standard()
            setFlagReport(false)
            toast.error("Failure! Unable to insert data. Try again later", {
              autoClose: 3000, // 3 seconds in this example
            })
          }
        })
        .catch(error => {
          //console.log(error)
          tog_standard()
          setFlagReport(false)
          if (
            (error?.response?.status === 403 || error?.response?.status === 401) &&
            (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
          ) {
            localStorage.clear()
            navigate("/login")
          }
        })
    // } else {
    //   setFlagReport(false)
    //   navigate("/login")
    // }
  }

  
const [selectedOptions, setSelectedOptions] = useState({}); // State to store selected options for each quspart
const [selectedOptionsMark, setSelectedOptionsMark] = useState({});
const handleCheckboxChange = (quspartId, optionId, mark) => {
    setSelectedOptions(prevState => ({
        ...prevState,
        [quspartId]: optionId,
    }));
    setSelectedOptionsMark(prevState => ({
      ...prevState,
      [quspartId]: mark,
  }));


};
const isAtLeastOneOptionChecked = (quspartId) => {
    return !!selectedOptions[quspartId];
};

const [markOverOptionCount, setMarkOverOptionCount] = useState(0);

const [IsSubmitbtn, setSubmitbtn] = useState(false);

useEffect(() => {
    // Update the count whenever the component mounts or the list changes
    const count = document.querySelectorAll('[data_count="mark_section"]').length;
    setMarkOverOptionCount(count);
    //console.log(Object.keys(selectedOptions).length)
    if(Object.keys(selectedOptions).length === count){
      setSubmitbtn(true);
    }else{
      setSubmitbtn(false);
    }
}, [isAtLeastOneOptionChecked])



const validationSchema = Yup.object().shape({
  percentageValue: Yup.number()
  .typeError('Must be a number')
  .min(0, 'Value cannot be negative')
  .max(100, 'Maximum value is 100')
  .test(
    'decimal',
    'Only one decimal place is allowed',
    (value) => value === undefined || /^\d+(\.\d{1})?$/.test(value.toString())
  )
  .required('Percentage is required')
  //.required('Feedback is required'),
});

const initialValues = {
  percentageValue: '', // Initially no value
  total_coins: ActivityData?.activity_node?.length > 0
                  ? ActivityData.activity_node[0].coins
                  : ActivityData?.LessonActivitiesQuestions?.length > 0
                  ? ActivityData.LessonActivitiesQuestions[0].question.length * 2
                  : 2,
};

const validation = useFormik({
  initialValues,
  validationSchema,
  enableReinitialize: true,
  onSubmit: async (values, { setSubmitting }) => {
    console.log('Form submitted:', values);
    //SUMMIT THE UPDATED WORKSHEET START
    setLinkSubmit(true);
    await convertAndSendPdf();
    //SUMMIT THE UPDATED WORKSHEET END
    setSubmitting(true);
    axios.defaults.headers.common["Authorization"] = `Bearer ${authTutorUser}`;
      const response = axios.post(
        BASE_URL+"session/StudentLCMSWorksheetManualMark",
        {
          ...values,
          pk_activity_key: pk_activity_key,
          fk_sub_id: IsType,
          pk_student_key: IsStKey,
          question_no: ActivityData.LessonActivitiesQuestions[0].fk_question_id,
          fk_ses_key: ActivityData.fk_sest_key,
          fk_lesson_key: ActivityData.fk_lesson_key,
          coins: ActivityData?.activity_node?.length > 0
                  ? ActivityData.activity_node[0].coins
                  : ActivityData?.LessonActivitiesQuestions?.length > 0
                  ? ActivityData.LessonActivitiesQuestions[0].question.length * 2
                  : 2,
          topic_id : ''
        }
      ).then(responseData => {
                //console.log(responseSessionEnd.data);
                // Assuming the API response is an array of objects with 'id' and 'value' properties
                if (parseInt(responseData.data) === 1) {
       
                  // localStorage.setItem("authTutorUser", JSON.stringify(response.data[0]['token']));
                  // props.router.navigate("/dashboard");
                  //console.log('success');
                  toast.success("Score and Coins assigned", {
                    autoClose: 3000, // 3 seconds in this example
                    onClose: () => {window.history.back()},
                  })
                  
                  setSubmitting(false)
                } else {
                  toast.error("Coins not assigned to student, Try again later", {
                    autoClose: 3000, // 3 seconds in this example
                  })
                  setSubmitting(false)
                }

    }).catch(error => {
      setSubmitting(false)
      if (
        (error?.response?.status === 403 || error?.response?.status === 401) &&
        (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
      ) {
        localStorage.clear()
        navigate("/login")
      }
    })
  },
});
  return (
    <React.Fragment>
      <Loader
        show={loader}
        type="body"
        // stack="vertical"
        // message="Loading Data"
      />
      <Modal isOpen={modal_standard1} toggle={tog_standard1}>
        <ModalHeader toggle={tog_standard1}></ModalHeader>
        <ModalBody>
          <p className="text-center fw-bold text-dark mb-0 font-size-18">
            Once submitted, you won’t be able to change the score.
          </p>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button
            color="danger"
            className="btn-cst-danger-md"
            onClick={() => {
              tog_standard1()
            }}
          >
            CANCEL
          </Button>

          <Button
            color="success"
            className="btn-cst-success-md"
              style={{
                border: "none",
                borderRadius: "8px",
                color: "#fff",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 700,
                letterSpacing: ".05em",
                padding: ".25rem 1.5rem",
                textTransform: "uppercase",
                backgroundColor: "#63d3a6",
                boxShadow: "0 4px 0 #4bb98d"
              }}
            disabled={isLinkSubmit}
            onClick={() => {
              if(validation?.values?.percentageValue && validation.values.percentageValue >= 0){
                validation.handleSubmit();
              }else{
                  toast.error("Please enter a valid percentage", {
                    autoClose: 3000, // 3 seconds in this example
                  })
                  setmodal_standard1(false);
              }
              
            }}
          >
            CONFIRM
          </Button>
        </ModalFooter>
      </Modal>
      <ToastContainer autoClose={3000} />
      
      {/* <Modal isOpen={modal_standard} toggle={tog_standard}>
        <ModalHeader toggle={tog_standard}>Flag this Question</ModalHeader>
        <ModalBody>
          <div className="flex-grow-1 mb-3 cs-rsm">
            <Label>Select a Reason</Label>
            <Select
              className="cs-style bg-mutant"
              value={optionGroup.find(
                option =>
                  option.value &&
                  selectedGroup &&
                  option.value.toString() == selectedGroup.toString()
              )}
              placeholder="Select"
              onChange={e => {
                handleSelectGroup(e.value)
              }}
              options={optionGroup}
              classNamePrefix="select2-selection"
            />
          </div>
          <div className="flex-grow-1 cs-rsm">
            <Label>Reason:</Label>
            <Input
              style={{ height: "200px" }}
              type="textarea"
              id="textarea"
              value={ResonTextData}
              onChange={e => {
                textareachange(e)
              }}
              maxLength="225"
              rows="3"
              placeholder="Write your reason here..."
            />
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button
            className="btn btn-danger cs-btn-danger"
            disabled={isFlagReport}
            onClick={() => {
              submitFlagReport()
            }}
          >
            Submit
          </Button>
        </ModalFooter>
      </Modal> */}
      <div className="page-wrapper">
        <div className="cs-pg-header bg-dark-blue py-4">
          <Container className="custom-wt">
            <div className="d-flex align-items-center">
              <div className="mt-0 border-right me-4" style={{ width: "20%" }}>
                
                  <div
                    className="text-white font-size-14 text-uppercase"
                    to={"#"}
                    onClick={() => history.back()}
                  >
                    {" "}
                    <span>
                      <i className=" fas fa-chevron-left me-1"></i>
                    </span>{" "}
                    back
                  </div>
                
              </div>
              <div className="d-flex align-items-center justify-content-between flex-grow-1">
                <h6 className="mb-0 font-size-20 text-white w-60 fw-regular">
                  {/* {ActivityData &&
                  ActivityData.activity_level_has_topic_node &&
                  ActivityData.activity_level_has_topic_node.length > 0
                    ? ActivityData.activity_level_has_topic_node[0]
                        .level_name != ""
                      ? ActivityData.activity_level_has_topic_node[0]
                          .level_name + "/"
                      : null
                    : null}
                  {ActivityData &&
                  ActivityData.activity_level_has_topic_node &&
                  ActivityData.activity_level_has_topic_node.length > 0
                    ? ActivityData.activity_level_has_topic_node[0]
                        .topic_name != ""
                      ? ActivityData.activity_level_has_topic_node[0]
                          .topic_name + "/"
                      : null
                    : null} */}
                    {ActivityData && ActivityData.level_name && ActivityData.level_name!='' ? ActivityData.level_name+' - ' : null}
                    {ActivityData && ActivityData.topic_name && ActivityData.topic_name!='' ? ActivityData.topic_name+' - ' : null}

                  {ActivityData &&
                  ActivityData.activity_node &&
                  ActivityData.activity_node.length > 0 && 
                  ActivityData.activity_node[0].name
                    ? ActivityData.activity_node[0].name
                    : ActivityData &&
                      ActivityData.activity_node &&
                      ActivityData.activity_node.length > 0 && 
                      ActivityData.activity_node[0].node_name
                    ? ActivityData.activity_node[0].node_name
                    : null}
                </h6>
                <p className="mb-0 text-uppercase luminous-wht">
                  {" "}
                  <span className="text-yellow me-1">
                    {ActivityData && ActivityData.subject_name
                      ? ActivityData.subject_name
                      : null}
                  </span>{" "}
                  Work Sheet{" "}
                </p>
                <div className="luminous-wht font-size-16">
                  <img width={24} className="" src={awicon} alt="" />{" "}
                  {ActivityData && ActivityData.coins_earned
                    ? ActivityData.coins_earned
                    : 0}
                  /
                  {ActivityData &&
                  ActivityData.activity_node &&
                  ActivityData.activity_node.length > 0 && 
                  ActivityData.activity_node[0].coins
                    ? ActivityData.activity_node[0].coins
                    : ActivityData &&
                  ActivityData.LessonActivitiesQuestions &&
                  ActivityData.LessonActivitiesQuestions.length > 0
                    ? ActivityData.LessonActivitiesQuestions[0].question
                        .length * 2
                    : 2}{" "}
                  coins
                </div>
              </div>
            </div>
          </Container>
        </div>
        {ActivityData &&
        ActivityData.LessonActivitiesQuestions &&
        ActivityData.LessonActivitiesQuestions.length > 0
          ? ActivityData.LessonActivitiesQuestions.map(
              (questionActivity, activeindex) => {
                if (
                  ActivityData.activity_node &&
                  ActivityData.activity_node.length > 0 
                ) {
                  return ActivityData.activity_node.map(
                    (InnerActivityData, index) => {
                      if (index === 0) {
                        return (
                          <div className="">
                             {/* <div className="tool-bar-worksheet">
                              <div className="worksheet-width-hold d-flex align-items-center justify-content-end">
                                  <div className="cs-tools d-flex align-items-center">
                                    {localStorage.getItem("is_trial") != '1' ?
                                      <button onClick={downloadPdf}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          class="bi bi-printer-fill fx-printer"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1" />
                                          <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                                        </svg>
                                      </button>
                                    : null}
                                  </div>
                              </div>
                            </div> */}
                            <div className="tool-bar-worksheet">
                              <div className="worksheet-width-hold d-flex align-items-center justify-content-between">
                                { (
                                  <>
                                    <div className="cs-tools d-flex align-items-center">
                                      <button
                                        className={pointerMode ? "active" : ""}
                                        onClick={togglePointerMode}
                                      >
                                        <svg xmlns="http://www.w3.org/2000/svg" 
                                        width="16" height="16" fill="currentColor" 
                                        class="bi bi-hand-index-thumb" viewBox="0 0 16 16">
                                          <path d="M6.75 1a.75.75 0 0 1 .75.75V8a.5.5 0 0 0 1 0V5.467l.086-.004c.317-.012.637-.008.816.027.134.027.294.096.448.182.077.042.15.147.15.314V8a.5.5 0 0 0 1 0V6.435l.106-.01c.316-.024.584-.01.708.04.118.046.3.207.486.43.081.096.15.19.2.259V8.5a.5.5 0 1 0 1 0v-1h.342a1 1 0 0 1 .995 1.1l-.271 2.715a2.5 2.5 0 0 1-.317.991l-1.395 2.442a.5.5 0 0 1-.434.252H6.118a.5.5 0 0 1-.447-.276l-1.232-2.465-2.512-4.185a.517.517 0 0 1 .809-.631l2.41 2.41A.5.5 0 0 0 6 9.5V1.75A.75.75 0 0 1 6.75 1M8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v6.543L3.443 6.736A1.517 1.517 0 0 0 1.07 8.588l2.491 4.153 1.215 2.43A1.5 1.5 0 0 0 6.118 16h6.302a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5 5 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.6 2.6 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046zm2.094 2.025"/>
                                        </svg>
                                      </button>
                                      <button
                                        className={drawMode ? "active" : ""}
                                        onClick={toggleDrawMode}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          class="bi bi-brush-fill"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.1 6.1 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.1 8.1 0 0 1-3.078.132 4 4 0 0 1-.562-.135 1.4 1.4 0 0 1-.466-.247.7.7 0 0 1-.204-.288.62.62 0 0 1 .004-.443c.095-.245.316-.38.461-.452.394-.197.625-.453.867-.826.095-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.201-.925 1.746-.896q.19.012.348.048c.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.176-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04" />
                                        </svg>
                                      </button>

                                      <button
                                        className={textMode ? "active" : ""}
                                        onClick={toggleTextMode}
                                      >
                                        {/* {textMode
                                      ? "Deactivate Text Mode"
                                      : "Activate Text Mode"} */}
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          class="bi bi-fonts super-size"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M12.258 3h-8.51l-.083 2.46h.479c.26-1.544.758-1.783 2.693-1.845l.424-.013v7.827c0 .663-.144.82-1.3.923v.52h4.082v-.52c-1.162-.103-1.306-.26-1.306-.923V3.602l.431.013c1.934.062 2.434.301 2.693 1.846h.479z" />
                                        </svg>
                                        


                                      </button>
                                      
                                      <div
                                        className={
                                          shapMode
                                            ? "fo-select active px-1"
                                            : "fo-select px-1"
                                        }
                                      >
                                        <button onClick={ClickShapeMode}>
                                          {selectedShape == "circle" ? (
                                            <div className="fs-circle"></div>
                                          ) : selectedShape == "rectangle" ? (
                                            <div className="fs-rectangle"></div>
                                          ) : selectedShape == "square" ? (
                                            <div className="fs-square"></div>
                                          ) : (
                                            "circle"
                                          )}
                                        </button>
                                        <select
                                          value={selectedShape}
                                          //onClick={(e) => ClickShapeMode(e.target.value)}
                                          onChange={e =>
                                            toggleShapeMode(e.target.value)
                                          }
                                        >
                                          <option value="circle">Circle</option>
                                          <option value="rectangle">
                                            Rectangle
                                          </option>
                                          <option value="square">Square</option>
                                        </select>
                                      </div>
                                      <button onClick={zoomIn}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          class="bi bi-zoom-in"
                                          viewBox="0 0 16 16"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
                                          />
                                          <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z" />
                                          <path
                                            fill-rule="evenodd"
                                            d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"
                                          />
                                        </svg>
                                      </button>
                                      <button onClick={zoomOut}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          class="bi bi-zoom-out"
                                          viewBox="0 0 16 16"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
                                          />
                                          <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z" />
                                          <path
                                            fill-rule="evenodd"
                                            d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"
                                          />
                                        </svg>
                                      </button>
                                      {/* <button onClick={undoAction}>Undo</button>
                                      <button onClick={redoAction}>Redo</button> */}
                                      <button onClick={removeSelectedObject}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          class="bi bi-eraser-fill"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828zm.66 11.34L3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293z" />
                                        </svg>
                                      </button>

                                      <div className="color-picker ps-1">
                                        <input
                                          type="color"
                                          value={currentColor}
                                          onChange={e =>
                                            changeColor(e.target.value)
                                          }
                                        />
                                      </div>

                                      {localStorage.getItem("is_trial") != '1' ?
                                        <button onClick={downloadPdf}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            class="bi bi-printer-fill fx-printer"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1" />
                                            <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                                          </svg>
                                        </button>
                                      : null }
                                      <div>
                                        Font Size:
                                        <div className="d-flex align-items-center">
                                            <button onClick={decreaseFontSize} style={{ margin: "unset", padding: "unset", height: "30px", width: "30px" }}>
                                              <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash" viewBox="0 0 16 16">
                                                <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"/>
                                              </svg>
                                            </button>
                                        
                                            {fontSize}px

                                            <button onClick={increaseFontSize}   style={{ margin: "unset", padding: "unset", height: "30px", width: "30px" }}>
                                              <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                              </svg>
                                            </button>
                                            
                                        </div>
                                      </div>
                                      <div >
                                        Brush Size:
                                        <div className="d-flex align-items-center">
                                            <button onClick={decreaseBrushSize} style={{ margin: "unset", padding: "unset", height: "30px", width: "30px" }}>
                                              <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash" viewBox="0 0 16 16">
                                                <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"/>
                                              </svg>
                                            </button>
                                            {brushSize}px
                                            
                                            <button onClick={increaseBrushSize} style={{ margin: "unset", padding: "unset", height: "30px", width: "30px" }}>
                                              <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                              </svg>
                                            </button>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="d-flex align-items-center mb-1">
                                      <Button
                                        className="btn btn-danger cs-btn-danger mt-1 w-20"
                                        onClick={() => {handleSaveProgress(canvasList)}}
                                      >
                                        SAVE PROGRESS
                                      </Button>
                                    </div>
                                  </>
                                ) }
                              </div>
                            </div>
                            <div className="assessement-section worksheet-width-hold mt-4">
                              <div className="hw-list mt-4 pb-100">
                                <ul className="list-unstyled mb-0">
                                  <li className="justify-content-between border-thick">
                                  <form>
                                      <div className="mark_over_option mb-4 p-2 gap-3 border" data_count="mark_section">
                                        <div className="badge bg-primary font-size-14 mt-auto mb-2">Manual Marking</div>
                                    
                                        <div className="action-btns d-flex justify-content-end gap-4 mt-5">
                                          <div className="d-flex align-items-center w-100 gap-1">  
                                            <label htmlFor="percentage mr-3">Mark in percentage : </label>
                                            <input
                                              className="form-control w-30"
                                              type="number"
                                              id="percentageValue"
                                              name="percentageValue"
                                              step="0.1" // Allows only one decimal place
                                              value={validation.values.percentageValue} // Fix: Correct value binding
                                              onChange={(event) => {
                                                let value = event.target.value;
                                                if (/^\d+(\.\d{0,1})?$/.test(value) || value === "") {
                                                  validation.setFieldValue("percentageValue", value); // Fix: Correct value assignment
                                                }
                                              }}
                                              onBlur={validation.handleBlur}
                                            />
                                            <label htmlFor="percentage ml-3">% </label>
                                            
                                        
                                              
                                          </div> 
                                          <div>
                                            <Button className="btn btn-danger cs-btn-danger mt-1 w-20" type="button"  onClick={tog_standard1} disabled={validation.isSubmitting}>
                                              SUBMIT
                                            </Button>
                                          </div>
                                        </div>
                                        
                                        {validation.touched.percentageValue && validation.errors.percentageValue && (
                                          <p style={{ color: 'red' }}>{validation.errors.percentageValue}</p>
                                        )}
                                          
                                      </div>
                                    </form>

                                    <div className="d-flex align-items-start gap-4 justify-content-end">
                                      <div className="mb-0 d-flex align-items-center gap-2">
                                        <p className="mb-0">
                                          #
                                          {InnerActivityData.pk_tutor_library_item_id
                                            ? InnerActivityData.pk_tutor_library_item_id
                                            : InnerActivityData.id
                                            ? InnerActivityData.id
                                            : null}
                                        </p>
                                        <span
                                         
                                        >
                                          <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                                        </span>
                                      </div>
                                    </div>

                                    {/* <div className="video-wrapper"> */}
                                    <div>
                                      <div>
                                        
                                      </div>
                                    </div>
                                    <div>
                                      <div id="Canvas_list"></div>
                                    </div>
                                    {/* </div> */}
                                  </li>
                                 
                                </ul>
                              </div>

                              
                            </div>
                          </div>
                        )
                      }
                    }
                  )
                }
              }
            )
          : null}
      </div>
    </React.Fragment>
  )
}

ManualWorkSheet.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(ManualWorkSheet)
